import React, { useState } from 'react';
import STAR_HALF from "../assets/star-half.png";
import STAR_FULL from "../assets/star-full.png";
import STAR_EMPTY from "../assets/star-empty.png";

const DynamicStarRating = ({ sendRatingToMain, setDefaultRating }) => {
  const [rating, setRating] = useState(setDefaultRating | 0);
  const [hoveredRating, setHoveredRating] = useState(0);

  const handleClick = (selectedRating) => {
    setRating(selectedRating);
  };

  const handleHover = (hoveredRating) => {
    setHoveredRating(hoveredRating);
  };

  const handleLeave = () => {
    setHoveredRating(0);
  };

  const renderStars = () => {
    const stars = [];
    const maxStars = 5;

    for (let i = 1; i <= maxStars; i++) {
      let starImage;
      if (i <= rating || i <= hoveredRating) {
        starImage = <img src={STAR_FULL} alt="Full Star" />;
      } else if (i - 0.5 === hoveredRating) {
        starImage = <img src={STAR_HALF} alt="Half Star" />;
      } else {
        starImage = <img src={STAR_EMPTY} alt="Empty Star" />;
      }

      stars.push(
        <span
          key={i}
          onClick={() => handleClick(i)}
          onMouseEnter={() => handleHover(i)}
          onMouseLeave={handleLeave}
        >
          {starImage}
        </span>
      );
    }
    sendRatingToMain(rating);
    return stars;
  };

  return (
    <div className="star-container">
      {renderStars()} {rating}/5 stars
    </div>
  );
};

export default DynamicStarRating;
